
# This class presents a simple marker toolbar on the map
class L.Control.MfPolyline extends L.Control.MfButtonGrid
    constructor: (@iconSize = 8) ->
        super()
        @setDefaults()

    setColor: (color) =>
        @color = color

    # set default options.
    setDefaults: () =>
        @options =
            position: 'topleft'
            toolbars: [
                {
                    style: {
                        width: '65px'
                    }
                    rows: [
                        [
                            { name: 'draw-polyline', html: '<span style="margin-left: -15px;"><i class="fa fa-pencil-alt"></i> Line</span>', toggle: true, style: { width: '66px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
            ]

    setStealthStyling: () =>
        @options =
            position: 'topleft'
            toolbars: [
                {
                    rows: []
                }
            ]

    setWithUndoStyling: () =>
        @options =
            position: 'topleft'
            toolbars: [
                {
                    style: {
                        width: '65px'
                    }
                    rows: [
                        [
                            { name: 'draw-polyline', html: '<span style="margin-left: -15px;"><i class="fa fa-pencil-alt"></i> Line</span>', toggle: true, style: { width: '66px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
                {
                    style: {
                        width: '65px'
                    }
                    rows: [
                        [
                            { name: 'draw-undo', html: '<span><i class="fa fa-reply"></i> Undo </span>', toggle: false, style: { width: '66px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
            ]

    setSliceStyling: () =>
        @options =
            position: 'topleft'
            toolbars: [
                {
                    style: {
                        width: '65px'
                        # height: '30px'
                    }
                    rows: [
                        [
                            { name: 'draw-polyline', html: '<span style="margin-left: -5px;"><img src="/img/slicing-icon.png" style="margin-bottom: 2px;height: 15px;width: 15px;" ></img> Slice</span>', toggle: true, style: { width: '66px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
                {
                    style: {
                        width: '65px'
                    }
                    rows: [
                        [
                            { name: 'draw-undo', html: '<span><i class="fa fa-reply"></i> Undo </span>', toggle: false, style: { width: '66px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
            ]

    # When the control is added to the map, register the callback and init the marker tool
    onAdd: (map) ->
        @map ?= map
        @mode = null
        @current_tool = null
        container = super(map)

        @addCallback 'draw-polyline', @drawMarker
        @addCallback 'draw-undo', @_undoPressed

        @map.on 'draw:created', @handleMarkerDrop

        @selectBtn 'draw-polyline'
        @drawMarker()

        return container

    _undoPressed: () =>
        @current_tool.disable() if @current_tool
        @fire('mfpolyline:undo')

    handleMarkerDrop: (e) =>
        @enableBtn 'draw-polyline'
        @deselectBtn 'draw-polyline'
        @fire('mfpolyline:created', e)

    # Handle initializing the marker tool
    drawMarker: () =>
        @disableBtn 'draw-polyline'
        @current_tool = new L.Draw.Polyline(@map,  {
            shapeOptions: {
                color: @color
                opacity: 1
                guidelineDistance: 10
                weight: 5
            }
            allowIntersection: false
            metric: false
            feet: true
        })

        # modify marker options so that we have a round icon
        @current_tool.options.icon.options.className = 'leaflet-marker-icon custom-circle-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable'

        @current_tool.options.icon.options.iconSize.x = @iconSize
        @current_tool.options.icon.options.iconSize.y = @iconSize

        @current_tool.enable()
        @fire('mfpolyline:tool_selected')

    deselect: () =>
        @current_tool.disable()


    select: () =>
        @current_tool.enable()
        @fire('mfpolyline:tool_selected')

    _lineSelected: (e) =>
        if not e.layer.options.poly
            e.layer.options.poly =
                color: e.layer.options.color,
                drawError: {
                    color: e.layer.options.color,
                    timeout: 1000
                }

        e.layer.options.poly.allowIntersection = false

        handler = new L.Edit.Poly(e.layer)

        handler.enable()
        @fire 'select:poly-selected'

        # Disable the previous selection
        if @current_tool?.h? and @current_tool?.h?.disable?
            @current_tool.h.disable()

        current_tool = {
            h: null
            disable: () ->
                @h.disable()
            active: true
        }

        current_tool?.h = handler

        return current_tool
